import(/* webpackMode: "eager" */ "/vercel/path0/app/templates/purchase/page.tsx");
